import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a8f80f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "dis-space-4 me-max-title"
}, "持续赋能大宗商品物流上下游全链路业务场景", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  const _component_SonBannerTabs = _resolveComponent("SonBannerTabs");
  const _component_Cooperation = _resolveComponent("Cooperation");
  const _component_ConsultModal = _resolveComponent("ConsultModal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "banner-box",
    style: _normalizeStyle({
      height: _ctx.bannerHeight
    })
  }, [_createElementVNode("div", {
    class: "banner-info",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_hoisted_2, _createVNode(_component_a_button, {
    class: "service me-content",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openConsultModdal())
  }, {
    default: _withCtx(() => [_createTextVNode("项目咨询")]),
    _: 1
  })], 4), _createVNode(_component_SonBannerTabs, _mergeProps({
    ref: "bannerTabsRef"
  }, {
    tabList: _ctx.tabList,
    componentName: _ctx.componentName
  }, {
    onCutTab: _ctx.handleCutTab
  }), null, 16, ["onCutTab"])], 4), (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentActiveMenu))), _createVNode(_component_Cooperation, {
    class: _normalizeClass({
      'gay-bg': ['energy', 'rail', 'chemical'].includes(_ctx.currentActiveMenu)
    }),
    title: "业务合作",
    onOpenConsultModdal: _ctx.openConsultModdal
  }, null, 8, ["class", "onOpenConsultModdal"]), _createVNode(_component_ConsultModal, {
    ref: "consultModalRef"
  }, null, 512)]);
}